import {RolesActions, RolesActionTypes} from './roles.actions';
import {initialState, rolesAdapter, RolesState} from './roles.state';

export function rolesReducer(
  state = initialState,
  action: RolesActions
): RolesState {
  switch (action.type) {
    // load
    case RolesActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case RolesActionTypes.LOAD_SUCCESS: {
      return rolesAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case RolesActionTypes.LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
